


















import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
    components: {
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./Dialogs/ConfirmDialog.vue")
    },
    props: {
        value: { type: Boolean, default: false }
    },
    setup(props, { emit }) {
        const showConfirm = ref<boolean>(false);
        const emitClick = () => {
            emit("click");
            showConfirm.value = false;
        };
        const onClick = () => {
            if (props && props.value) {
                showConfirm.value = true;
            } else {
                emitClick();
            }
        };
        return {
            onClick,
            showConfirm,
            emitClick
        };
    }
});
